// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__15dp-","cell_list_item":"styles_cell_list_item__3hxTb"};